import { Link, useParams } from "react-router-dom";
import {
    Chip,
    SpinAnimation,
    ImageList,
    ProfileImage,
} from "@twioku/common_components";
import { useActivityReplies } from "../features/activityReply/hooks/useActivityReplies";
import { toFormatString } from "../libs/helper";

export const ActivityDetailPage = () => {
    const params = useParams();
    const id = params.id as string;

    const { activityReplies, isLoading: isActivityRepliesLoading } =
        useActivityReplies(id);

    if (isActivityRepliesLoading || !activityReplies) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    return (
        <main className="mx-auto h-full w-full max-w-5xl">
            <div className="flex h-full w-full max-w-5xl">
                <div className="mx-4 flex-1 pb-36">
                    <article className="mb-4 mt-2">
                        <section>
                            <header>
                                <h2 className="mt-6 border-l-4 border-primary px-3 text-lg">
                                    {activityReplies[0].activityTitle}
                                </h2>
                            </header>
                        </section>
                    </article>
                    <ul>
                        {activityReplies.map((activityReply) => (
                            <li key={activityReply.id} className="mt-2">
                                <Link
                                    to={`/activity-reply/${activityReply.id}`}
                                >
                                    <div className="flex items-end justify-between p-1">
                                        <div className="flex">
                                            <span className="my-auto text-gray-600">
                                                {toFormatString(
                                                    new Date(
                                                        activityReply.respondDate
                                                    ),
                                                    true,
                                                    "/"
                                                )}
                                            </span>
                                            {(activityReply.isUnread ||
                                                activityReply.hasUnreadComment) && (
                                                <div className="my-auto ml-2">
                                                    <Chip color="success">
                                                        新着あり
                                                    </Chip>
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex">
                                            <ProfileImage
                                                src={
                                                    activityReply.answererProfleImagePath
                                                }
                                                size="x-small"
                                            />
                                            <span className="my-auto block px-3">
                                                {activityReply.answererName}
                                            </span>
                                        </div>
                                    </div>
                                    <ImageList
                                        srcList={activityReply.imagePaths ?? []}
                                        className="pointer-events-none"
                                    />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </main>
    );
};
